import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { getPostcodes } from './PostcodeActions';
import { dataToSelect } from '../../../common/helpers/dataToSelect';
import FormAsyncSelectField from '../../../common/components/formFields/FormAsyncSelectField';
import FormAsyncSelectFieldBordered from '../../../common/components/formFields/FormAsyncSelectFieldBordered';
import { FormRegExp } from '../../../constants/FormRegExp';
import { BORDERED_LABEL_VARIANT } from '../../../constants/LabelVariants';

function PostcodeSelectField(props) {
  const dispatch = useDispatch();
  const { labelVariant } = props || {};

  const loadOptions = (inputValue, callback) => {
    const upperValue = inputValue?.toUpperCase() || '';

    if (
      (upperValue &&
        (upperValue.length < 2 || upperValue.length > 8) &&
        props?.loadRightAway) ||
      (!props?.loadRightAway && upperValue && upperValue.length > 8) ||
      (!isEmpty(upperValue.charAt(0)) &&
        !upperValue.charAt(0).match(FormRegExp.STRING_ONLY_LETTERS)) ||
      (!isEmpty(upperValue.charAt(6)) &&
        !upperValue.charAt(6).match(FormRegExp.STRING_ONLY_LETTERS))
    ) {
      callback(false);
      return false;
    }

    dispatch(
      getPostcodes(inputValue, (postcodes) => {
        callback(dataToSelect(postcodes.data, ['id', 'postcode']));
      }),
    );
    return true;
  };

  if (labelVariant === BORDERED_LABEL_VARIANT) {
    return (
      <FormAsyncSelectFieldBordered
        {...props}
        loadOptions={loadOptions}
        loadRightAway={props?.loadRightAway}
        defaultOptions
      />
    );
  }

  return (
    <FormAsyncSelectField
      {...props}
      loadOptions={loadOptions}
      loadRightAway={props?.loadRightAway}
      defaultOptions
    />
  );
}

PostcodeSelectField.defaultProps = {
  loadRightAway: true,
  labelVariant: 'default',
};

PostcodeSelectField.propTypes = {
  loadRightAway: PropTypes.bool,
  labelVariant: PropTypes.string,
};

export default PostcodeSelectField;
